import React from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock,   InlineCode,   SectionTitle,  Note,  TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider, Image} from '../../../../components/course/CourseComponents';
import screen1 from '../screen1.jpg';

const IntroductionContent = () => {
  return (
    <>
       <InfoBox title="Introduction" color="blue">
        <p className="mb-0">
        Il est temps de coder un second jeu qui fera intervenir d'autres notions comme les tableaux !<br/>
        Aujourd'hui, on s'attaque à un jeu de Morpion, un petit jeu très connu où deux joueurs s’affrontent pour aligner trois symboles dans une grille.
        </p>
      </InfoBox>    

      <SectionTitle>🧠 Objectif du jeu</SectionTitle>
      
     

     

      <div className="flex flex-col md:flex-row gap-6 items-start mb-6">
        <div className="flex-1">
      
        <p className="mb-4">
        Le jeu de morpion, aussi appelé tic-tac-toe, est un jeu très simple pour 2 joueurs. Voici comment il fonctionne :
      </p>
          <ul className="list-disc list-inside mb-4">
            <li>On joue sur une grille de 3 cases sur 3.</li>
            <li>Un joueur joue avec le symbole X, l'autre avec le O.</li>
            <li>À tour de rôle, chaque joueur place son symbole dans une case vide.</li>
            <li>Le but est d’aligner 3 symboles identiques : en ligne, en colonne ou en diagonale.</li>
            <li>Si la grille est remplie sans qu’il y ait d’alignement, c’est match nul.</li>
          </ul>
        </div>
        <div className="flex justify-center items-center">
          <Image 
            src={screen1} 
            alt="Aperçu du jeu de visée" 
            width="350px"
            height="350px"
            borderRadius="xl"
            shadow={true}
            border={false}
            className="object-contain"
          />
        </div>
      </div>

      <Note type="tip" title="Technologie utilisée :">
        Comme pour Ameliore ta visée, nous utiliserons JavaScript et la bibliothèque p5.js, qui fournit toutes les fonctions nécessaires à la création de jeux vidéo : interface simple pour gérer le rendu graphique, gérer les événements utilisateur et l'interaction en temps réel.
      </Note>

      <p>
      🎯 Prêt à coder ? C'est parti !
      </p>
     
    </>
  );
};

export default IntroductionContent; 